import * as React from "react"
import { ChildrenProps } from "../../../@types/CapioWeb/core"
import { UnitFilterValue } from '../CapioNexusUnitFilterBlock'
import { setFilterQueryParams } from "../../../utils/filterHistory"

export interface UnitFilterContextValue {
	activeRegionIds?: string[]
	updateActiveRegionIds: (key: string) => void
	setActiveRegionIds: React.Dispatch<React.SetStateAction<string[]>>
	activeCareTypeIds: string[]
	updateActiveCareTypeIds: (key: string) => void
	setActiveCareTypeIds: React.Dispatch<React.SetStateAction<string[]>>
	activeDiagnoseFirstLevelIds: string[]
	updateActiveDiagnoseFirstLevelIds: (key: string) => void
	setActiveDiagnoseFirstLevelIds: React.Dispatch<React.SetStateAction<string[]>>
	activeDiagnoseSecondLevelIds: string[]
	updateActiveDiagnoseSecondLevelIds: (key: string) => void
	setActiveDiagnoseSecondLevelIds: React.Dispatch<React.SetStateAction<string[]>>
	activeCareTypeFilterValues: UnitFilterValue[]
	setActiveCareTypeFilterValues: React.Dispatch<React.SetStateAction<any[]>>
	activeDiagnoseFirstLevelFilterValues: UnitFilterValue[]
	setActiveDiagnoseFirstLevelFilterValues: React.Dispatch<React.SetStateAction<any[]>>
	activeDiagnoseSecondLevelFilterValues: UnitFilterValue[]
	setActiveDiagnoseSecondLevelFilterValues: React.Dispatch<React.SetStateAction<any[]>>
	resetFilters: () => void
	totalHits?: number
	setTotalHits?: React.Dispatch<React.SetStateAction<number>>

	// checkAll: (checked: boolean, filterValues: UnitFilterValue[], filterType: 'careType' | 'fieldOfCare') => void

}

export const UnitFilterContext = React.createContext<UnitFilterContextValue>({
	activeRegionIds: [],
	updateActiveRegionIds: (key: string) => null,
	setActiveRegionIds: () => null,
	activeCareTypeIds: [],
	updateActiveCareTypeIds: (key: string) => null,
	setActiveCareTypeIds: () => null,
	activeDiagnoseFirstLevelIds: [],
	updateActiveDiagnoseFirstLevelIds: (key: string) => null,
	setActiveDiagnoseFirstLevelIds: () => null,
	activeDiagnoseSecondLevelIds: [],
	updateActiveDiagnoseSecondLevelIds: (key: string) => null,
	setActiveDiagnoseSecondLevelIds: () => null,
	activeCareTypeFilterValues: [],
	setActiveCareTypeFilterValues: () => null,
	activeDiagnoseSecondLevelFilterValues: [],
	setActiveDiagnoseSecondLevelFilterValues: () => null,
	activeDiagnoseFirstLevelFilterValues: [],
	setActiveDiagnoseFirstLevelFilterValues: () => null,
	resetFilters: () => null,
	totalHits: 0,
	setTotalHits: () => null

	// checkAll: () => null
})

interface UnitFilterContextProps extends ChildrenProps {
	regionsFromQuery: string[]
	careTypesFromQuery: string[]
	diagnosesFromQuery: string[]
	diagnosesLevel2FromQuery: string[]
}

export const UnitFilterContextProvider: React.FC<UnitFilterContextProps> = (props) => {
	const [activeRegionIds, setActiveRegionIds] = React.useState<string[]>(props.regionsFromQuery)
	const [activeCareTypeIds, setActiveCareTypeIds] = React.useState<string[]>(props.careTypesFromQuery)
	const [activeDiagnoseFirstLevelIds, setActiveDiagnoseFirstLevelIds] = React.useState<string[]>(props.diagnosesFromQuery)
	const [activeDiagnoseSecondLevelIds, setActiveDiagnoseSecondLevelIds] = React.useState<string[]>(props.diagnosesLevel2FromQuery)

	const [totalHits, setTotalHits] = React.useState<number>(0)

	const [activeCareTypeFilterValues, setActiveCareTypeFilterValues] = React.useState<UnitFilterValue[]>([])
	const [activeDiagnoseFirstLevelFilterValues, setActiveDiagnoseFirstLevelFilterValues] = React.useState<UnitFilterValue[]>([])
	const [activeDiagnoseSecondLevelFilterValues, setActiveDiagnoseSecondLevelFilterValues] = React.useState<UnitFilterValue[]>([])

	const updateActiveRegionIds = (key: string) => {

		setActiveRegionIds(
			activeRegionIds.includes(key)
				? activeRegionIds.filter((activeKey) => activeKey !== key)
				: [...activeRegionIds, key]
		)
		if (activeRegionIds.length <= 1 && activeRegionIds.includes(key)) {
			setFilterQueryParams("caretypes", [])
			setFilterQueryParams("careareas", [])
			setFilterQueryParams("diagnoses", [])
			setActiveCareTypeIds([])
			setActiveDiagnoseFirstLevelIds([])
			setActiveDiagnoseSecondLevelIds([])
		}
		setFilterQueryParams("regions", activeRegionIds.includes(key)
			? activeRegionIds.filter((activeKey) => activeKey !== key)
			: [...activeRegionIds, key])
	}

	const updateActiveCareTypeIds = (key: string) => {
		setActiveCareTypeIds(
			activeCareTypeIds.includes(key)
				? activeCareTypeIds.filter((activeKey) => activeKey !== key)
				: [...activeCareTypeIds, key]
		)
		if (activeCareTypeIds.length === 1 && activeCareTypeIds.includes(key)) {
			setFilterQueryParams("careareas", [])
			setFilterQueryParams("diagnoses", [])
			setActiveDiagnoseFirstLevelIds([])
			setActiveDiagnoseSecondLevelIds([])
		}
		setFilterQueryParams("caretypes", activeCareTypeIds.includes(key)
			? activeCareTypeIds.filter((activeKey) => activeKey !== key)
			: [...activeCareTypeIds, key])
	}

	const updateActiveDiagnoseFirstLevelIds = (key: string) => {
		setActiveDiagnoseFirstLevelIds(
			activeDiagnoseFirstLevelIds.includes(key)
				? activeDiagnoseFirstLevelIds.filter((activeKey) => activeKey !== key)
				: [...activeDiagnoseFirstLevelIds, key]
		)

		if (activeDiagnoseFirstLevelIds.length > 0) {
			setFilterQueryParams("diagnoses", [])
			setActiveDiagnoseSecondLevelIds([])
		}
		setFilterQueryParams("careareas", activeDiagnoseFirstLevelIds.includes(key)
			? activeDiagnoseFirstLevelIds.filter((activeKey) => activeKey !== key)
			: [...activeDiagnoseFirstLevelIds, key])
	}

	const updateActiveDiagnoseSecondLevelIds = (key: string) => {
		setActiveDiagnoseSecondLevelIds(
			activeDiagnoseSecondLevelIds.includes(key)
				? activeDiagnoseSecondLevelIds.filter((activeKey) => activeKey !== key)
				: [...activeDiagnoseSecondLevelIds, key]
		)
		setFilterQueryParams("diagnoses", activeDiagnoseSecondLevelIds.includes(key)
			? activeDiagnoseSecondLevelIds.filter((activeKey) => activeKey !== key)
			: [...activeDiagnoseSecondLevelIds, key])
	}
	const resetFilters = () => {
		setActiveRegionIds([])
		setActiveCareTypeIds([])
		setActiveDiagnoseFirstLevelIds([])
		setActiveDiagnoseSecondLevelIds([])
	}

	// const checkAll = (checked: boolean, filterValues: UnitFilterValue[], filterType: 'careType' | 'fieldOfCare') => {
	// 	if (checked) {
	// 		const allFilters = filterValues.map(filter => filter.id)
	// 		filterType === 'careType' ? setActiveCareTypeIds(allFilters) : setActiveDiagnoseFirstLevelIds(allFilters)
	// 	} else {
	// 		if (filterType === 'careType') {
	// 			setActiveCareTypeIds([])
	// 			setActiveDiagnoseFirstLevelIds([])
	// 			setActiveDiagnoseSecondLevelIds([])
	// 		} else {
	// 			setActiveDiagnoseFirstLevelIds([])
	// 			setActiveDiagnoseSecondLevelIds([])
	// 		}
	// 	}
	// }

	return (
		<UnitFilterContext.Provider
			value={{
				activeRegionIds,
				updateActiveRegionIds,
				setActiveRegionIds,
				activeCareTypeIds,
				updateActiveCareTypeIds,
				setActiveCareTypeIds,
				activeDiagnoseFirstLevelIds,
				updateActiveDiagnoseFirstLevelIds,
				setActiveDiagnoseFirstLevelIds,
				activeDiagnoseSecondLevelIds,
				updateActiveDiagnoseSecondLevelIds,
				setActiveDiagnoseSecondLevelIds,
				activeCareTypeFilterValues,
				setActiveCareTypeFilterValues,
				activeDiagnoseFirstLevelFilterValues,
				setActiveDiagnoseFirstLevelFilterValues,
				activeDiagnoseSecondLevelFilterValues,
				setActiveDiagnoseSecondLevelFilterValues,
				resetFilters,
				totalHits,
				setTotalHits,
				// checkAll
			}}
		>
			{props.children}
		</UnitFilterContext.Provider>
	)
}
